import { ApplicationAgentContractResponse } from '@acme/api';
import { CopyableText, Separator, renderFieldIfText } from '@acme/foundation';

export const AgentRequisites = ({
  agentContract,
}: {
  agentContract: ApplicationAgentContractResponse | null;
}) => {
  if (!agentContract) return null;

  return (
    <>
      <Separator className="-mx-6" />
      <div className="flex flex-col gap-4">
        <div className="text-xl font-semibold text-gray-900">
          Реквизиты агента
        </div>

        <div className="grid grid-cols-3 gap-6">
          {renderFieldIfText('Сеть', agentContract.agentWalletNet?.name)}
          <div className="flex flex-col gap-1 flex-1 min-w-0 col-span-2">
            <p className="text-sm text-gray-500">Криптоадрес кошелька агента</p>
            <CopyableText
              value={agentContract.agentWallet}
              className="items-center text-gray-900 text-base font-medium"
            />
          </div>
        </div>
      </div>
    </>
  );
};
